import React from 'react';
import { InfoIcon } from "@vwfs-bronson/bronson-react";

export default function InfoIconExtendedLink(params: { label: string; href: string }) {

  return (
    <InfoIcon className="semantic-info" testId="infoIconInvoicesData" tippyProps={{
      appendToBody: true,
    }}>
      <a href={params.href} target='blank'>{params.label}</a>
    </InfoIcon>
  );
}